import React from 'react';

const SideNav = (props) => {
    return (
        <>
            <div
                className={`w-full px-4 py-3 text-sm font-medium rounded-lg cursor-pointer transition-all duration-200 ${
                    props.curPath === props.route
                        ? 'bg-blue-600 text-white shadow-md'
                        : 'text-gray-700 hover:bg-gray-100 hover:text-blue-600'
                }`}
                onClick={() => props.goToPage(props.route)}
            >
                {props.name}
            </div>
        </>
    );
};

export default SideNav;
